var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 5v14l11-7z"}));
}

Play.defaultProps = {"stroke":"currentColor","fill":"currentColor","strokeWidth":"0","viewBox":"0 0 24 24"};

module.exports = Play;

Play.default = Play;
